import { render, staticRenderFns } from "./ExternalDashboardModal.vue?vue&type=template&id=525e29ae&scoped=true&"
import script from "./ExternalDashboardModal.vue?vue&type=script&lang=js&"
export * from "./ExternalDashboardModal.vue?vue&type=script&lang=js&"
import style0 from "./ExternalDashboardModal.vue?vue&type=style&index=0&id=525e29ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e29ae",
  null
  
)

export default component.exports